import React from "react";
import { Link } from "react-router-dom";
import "./style.css";
import FollowUs from "../followUs/index";
import { socialprofils } from "../../content_option";
import {
  SlSocialFacebook,
  SlSocialInstagram,
  SlSocialYoutube,
} from "react-icons/sl";

const Footer = () => {
  return (
    <>
      <div className="container ftr mt-5  " style={{ backgroundColor: "#dedad1", maxWidth: "100%" }}>
        <FollowUs />
      </div>
    </>
  );
};

export default Footer;
